/* eslint-disable */
/* tslint:disable */

/** getSpecialties
 * method: get
 * summary: Get Hublo Pool application specialties
 */

import type { GetSpecialtiesResponseDto, ApiResponseDto } from './../api-types'

export const path = `/bff-worker/pool/application/specialties`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/pool/application/specialties`

export type GetSpecialtiesSuccess = GetSpecialtiesResponseDto
export type GetSpecialtiesError = ApiResponseDto
